import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const marcarEnviadoReciboF = createAsyncThunk(
  'reciboForm/marcarEnviadoReciboF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarEnviadoReciboF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarRecepcionadoReciboF = createAsyncThunk(
  'reciboForm/marcarRecepcionadoReciboF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.marcarRecepcionadoReciboF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);
